import { NgModule, ModuleWithProviders } from '@angular/core';

import { SvgIconComponent } from './svg-icon.component';

import { SVG_SPRITE_URL } from './svg-icon.tokens';

@NgModule({
  imports: [SvgIconComponent],
  exports: [SvgIconComponent],
})
export class SvgIconModule {
  static forRoot(config?: { spriteUrl?: string }): ModuleWithProviders<SvgIconModule> {
    return {
      ngModule: SvgIconModule,
      providers: [{ provide: SVG_SPRITE_URL, useValue: config?.spriteUrl }],
    };
  }
}
